import { GraphSplitAdapter } from "../../../../../graphics/graph-split-adapter";

export class chooseCmpxGraphMainAdapter extends GraphSplitAdapter {
    signalLength;

    constructor(props) {
        super(props);
        this.cursorCallback = props.cursorCallback;
        this.signalLength = props.signalLength;
    }

    setupCursors = async () => {
        const contentGroups = this.chartProvider.charts;

        contentGroups.forEach((item, index) => {
            const measurerContentGroup = item.findContentGroup("measurer");
            if (measurerContentGroup !== undefined) {
                const measurerGroup = measurerContentGroup;
                const cursor = measurerGroup.findByName("cursor");
                if (cursor !== undefined) {
                    if (index === 0) {
                        this.leftCursor = cursor;
                    } else {
                        this.rightCursor = cursor;
                    }
                }
            }
        });

        if (this.leftCursor) {
            this.leftCursor.addEventListener("PositionChanged", async target =>
                this.onPositionChanged(target, this.rightCursor, this.leftCursor)
            );
        }

        if (this.rightCursor) {
            this.rightCursor.addEventListener("PositionChanged", async target =>
                this.onPositionChanged(target, this.leftCursor, this.rightCursor)
            );
        }
    };

    setupRectangles = async () => {
        const contentGroups = this.chartProvider.charts;

        contentGroups.forEach((item, index) => {
            const rectContentGroup = item.findContentGroup("rectangle");
            if (rectContentGroup !== undefined) {
                const rectGroup = rectContentGroup;
                const hovered = rectGroup.findByName("hovered");
                const select = rectGroup.findByName("select");
                if (index === 0) {
                    this.leftHoverRect = hovered;
                    this.leftSelectRect = select;
                } else {
                    this.rightHoverRect = hovered;
                    this.rightSelectRect = select;
                }
            }
        });
    };

    moveHoverRectangles = async (x, width) => {
        const xInPx = this.valueConverter.convertPointsToPixels(x, this.fd);
        const widthInPx = this.valueConverter.convertPointsToPixels(width, this.fd);

        if (!isNaN(xInPx) && !isNaN(widthInPx)) {
            await Promise.all([
                this.leftHoverRect.move(xInPx),
                this.leftHoverRect.resize(widthInPx),
                this.rightHoverRect.move(xInPx),
                this.rightHoverRect.resize(widthInPx)
            ]);
        }
    };

    setHoverRectanglesFillColor = async color => {
        await Promise.all([this.leftHoverRect.setBackgroundFillColor(color), this.rightHoverRect.setBackgroundFillColor(color)]);
    };

    moveSelectRectangles = async (x, width) => {
        const xInPx = this.valueConverter.convertPointsToPixels(x, this.fd);
        const widthInPx = this.valueConverter.convertPointsToPixels(width, this.fd);
        await Promise.all([
            this.leftSelectRect.move(xInPx),
            this.leftSelectRect.resize(widthInPx),
            this.rightSelectRect.move(xInPx),
            this.rightSelectRect.resize(widthInPx)
        ]);
    };

    hideSelectRectangles = async isVisible => {
        await Promise.all([this.leftSelectRect.setVisibility(isVisible), this.rightSelectRect.setVisibility(isVisible)]);
    };

    moveCursors = async x => {
        const convertedValue = this.valueConverter.convertPointsToPixels(x, this.fd);
        await Promise.all([
            await this.moveCursorWithOutEvent(this.leftCursor, convertedValue),
            await this.moveCursorWithOutEvent(this.rightCursor, convertedValue)
        ]);
    };

    onPositionChanged = async (target, oppositeCursor, mainCursor) => {
        let { position } = target;
        const signalLengthInPixels = this.valueConverter.convertPointsToPixels(this.signalLength, this.fd);
        if (position >= signalLengthInPixels) {
            position = signalLengthInPixels;
            this.moveCursorWithOutEvent(mainCursor, position);
        }

        this.moveCursorWithOutEvent(oppositeCursor, position);
        this.cursorCallback(this.valueConverter.convertPixelsToPoints(position, this.fd));
    };

    moveCursorWithOutEvent = async (cursor, x) => {
        cursor.disableEvent("PositionChanged");
        await cursor.move(x);
        cursor.enableEvent("PositionChanged");
    };
}
